export default __webpack_public_path__ + "static/c_member_1-79111956f56d80cb86aeb6164ac8d486.jpg";